import { suomifiDesignTokens, } from 'suomifi-design-tokens';
export var spacing = suomifiDesignTokens.spacing;
export var spacingTokensKeys = Object.keys(spacing);
//# sourceMappingURL=spacing.js.map